// Image validation and resizing helper function
export const validateAndResizeImage = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const width = img.width;
      const height = img.height;

      // console.log('Image dimensions:', { width, height });

      // Check minimum dimensions
      if (width < 200 || height < 200) {
        const fileType = file.type === 'image/gif' ? 'GIF' : 'Image';
        reject({
          error: `${fileType} must be at least 200x200 pixels`,
          type: 'too_small'
        });
        return;
      }

      // Check maximum dimensions
      if (width > 1024 || height > 1024) {
        const fileType = file.type === 'image/gif' ? 'GIF' : 'Image';
        reject({
          error: `${fileType} must not exceed 1024x1024 pixels`,
          type: 'too_large'
        });
        return;
      }

      // If image is already square, use it as is
      if (width === height) {
        resolve(file);
        return;
      }

      // For GIFs, preserve animation by not resizing (even if non-square)
      if (file.type === 'image/gif') {
        resolve(file);
        return;
      }

      // If image is not square, resize it to target size
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const targetSize = 800;

      canvas.width = targetSize;
      canvas.height = targetSize;

      // Draw the image centered and scaled to fit
      ctx.drawImage(img, 0, 0, targetSize, targetSize);

      // Convert canvas to blob
      canvas.toBlob((blob) => {
        if (blob) {
          const resizedFile = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now()
          });
          resolve(resizedFile);
        } else {
          reject({
            error: 'Failed to resize image',
            type: 'resize_error'
          });
        }
      }, file.type, 0.9);
    };

    img.onerror = () => {
      reject({
        error: 'Failed to load image',
        type: 'load_error'
      });
    };

    reader.onerror = () => {
      reject({
        error: 'Failed to read file',
        type: 'read_error'
      });
    };

    reader.readAsDataURL(file);
  });
};
